import { render, staticRenderFns } from "./AdministratorDigest.vue?vue&type=template&id=95cf8118&"
import script from "./AdministratorDigest.vue?vue&type=script&lang=ts&"
export * from "./AdministratorDigest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports